import React from "react";
import {useSearchParams} from "react-router-dom";
import FamilyTree from "../familyTree";

export const Family = () => {
    const [searchParams] = useSearchParams();
    const memberId = searchParams.get("member");
    return (
        <div className="page">
            <FamilyTree key={memberId} initialMemberId={memberId} />
        </div>
    );
};
